module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.projectID == '') ? _c('div', [_c('div', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("common.no_project_loaded")) + ".")])])]) : (!_vm.hasData) ? _c('div', [_c('div', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("common.no_data_loaded")))])])]) : _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('help', {
    attrs: {
      "reflink": "geospatial",
      "label": _vm.$t("geospatial.Define geospatial optimizations")
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover table-striped",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("Name")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("Status")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("Actions")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.geoSummaries), function(geoSummary) {
    return _c('tr', [_c('td', [_c('b', [_vm._v(_vm._s(geoSummary.name))])]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.statusFormatStr(geoSummary)) + "\n            " + _vm._s(_vm.timeFormatStr(geoSummary)) + "\n          ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_c('button', {
      staticClass: "btn __green",
      attrs: {
        "disabled": !_vm.canRunTask(geoSummary)
      },
      on: {
        "click": function($event) {
          return _vm.runGeo(geoSummary, 'full')
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("common.Run")))]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      attrs: {
        "disabled": !_vm.canRunTask(geoSummary)
      },
      on: {
        "click": function($event) {
          return _vm.runGeo(geoSummary, 'test')
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("common.Test run")))]), _vm._v(" "), _c('button', {
      staticClass: "btn __green",
      attrs: {
        "disabled": !_vm.canPlotResults(geoSummary)
      },
      on: {
        "click": function($event) {
          return _vm.plotGeospatial(geoSummary)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("common.Plot results")))]), _vm._v(" "), _c('button', {
      staticClass: "btn __red",
      attrs: {
        "disabled": !_vm.canCancelTask(geoSummary)
      },
      on: {
        "click": function($event) {
          return _vm.clearTask(geoSummary)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("common.Clear results")))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-icon",
      attrs: {
        "data-tooltip": _vm.$t("geospatial.Edit geospatial optimization")
      },
      on: {
        "click": function($event) {
          return _vm.editGeoModal(geoSummary)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-icon",
      attrs: {
        "data-tooltip": _vm.$t("geospatial.Copy geospatial optimization")
      },
      on: {
        "click": function($event) {
          return _vm.copyGeo(geoSummary)
        }
      }
    }, [_c('i', {
      staticClass: "ti-files"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-icon",
      attrs: {
        "data-tooltip": _vm.$t("geospatial.Delete geospatial optimization")
      },
      on: {
        "click": function($event) {
          return _vm.deleteGeo(geoSummary)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    })])])])
  }), 0)]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": !_vm.geosLoaded
    },
    on: {
      "click": function($event) {
        return _vm.addGeoModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("geospatial.Add geospatial optimization")))])])], 1)]), _vm._v(" "), (_vm.hasGraphs) ? _c('div', {
    staticClass: "card full-width-card"
  }, [_c('div', {
    staticClass: "calib-title"
  }, [_c('help', {
    attrs: {
      "reflink": "results-plots",
      "label": "Results"
    }
  }), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-icon",
    attrs: {
      "data-tooltip": _vm.$t("common.Zoom out")
    },
    on: {
      "click": function($event) {
        return _vm.scaleFigs(0.9)
      }
    }
  }, [_vm._v("–")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon",
    attrs: {
      "data-tooltip": _vm.$t("common.Reset zoom")
    },
    on: {
      "click": function($event) {
        return _vm.scaleFigs(1.0)
      }
    }
  }, [_c('i', {
    staticClass: "ti-zoom-in"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon",
    attrs: {
      "data-tooltip": _vm.$t("common.Zoom in")
    },
    on: {
      "click": function($event) {
        return _vm.scaleFigs(1.1)
      }
    }
  }, [_vm._v("+")]), _vm._v("\n           \n        "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.exportGraphs(_vm.projectID, _vm.displayResultDatastoreId)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.Export plots")))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.exportResults(_vm.projectID, _vm.displayResultDatastoreId)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.Export data")))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "calib-main",
    class: {
      'calib-main--full': true
    }
  }, [_c('div', {
    staticClass: "calib-graphs"
  }, [_c('div', {
    staticClass: "other-graphs"
  }, _vm._l((_vm.placeholders), function(index) {
    return _c('div', {
      staticClass: "calib-graph",
      attrs: {
        "id": 'fig' + index
      }
    })
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.table) ? _c('div', [_c('help', {
    attrs: {
      "reflink": "cost-effectiveness",
      "label": "Program cost-effectiveness"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "calib-graphs",
    staticStyle: {
      "display": "inline-block",
      "text-align": "right",
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-hover table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("geospatial.Optimization/program")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("Outcomes")))]), _vm._v(" "), _vm._l((_vm.table[0].length - 3), function(i) {
    return _c('th')
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.table), function(rowdata) {
    return _c('tr', _vm._l(((rowdata.length - 1)), function(i) {
      return _c('td', [(rowdata[0] === 'header') ? _c('span', {
        staticStyle: {
          "font-size": "15px",
          "font-weight": "bold"
        }
      }, [_vm._v(_vm._s(rowdata[i]))]) : (rowdata[0] === 'keys' && i == 1) ? _c('span', {
        staticStyle: {
          "font-size": "12px",
          "font-style": "italic"
        }
      }, [_vm._v(_vm._s(rowdata[i]))]) : (rowdata[0] === 'keys' && i != 1) ? _c('span', {
        staticStyle: {
          "font-size": "12px",
          "font-weight": "bold"
        }
      }, [_vm._v(_vm._s(rowdata[i]))]) : (rowdata[0] === 'entry' && i == 1) ? _c('span', {
        staticStyle: {
          "font-size": "12px",
          "font-weight": "bold"
        }
      }, [_vm._v(_vm._s(rowdata[i]))]) : (rowdata[0] === 'entry' && i != 1) ? _c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v("                 " + _vm._s(rowdata[i]))]) : _c('span', [_c('div', {
        staticStyle: {
          "min-height": "30px"
        }
      })])])
    }), 0)
  }), 0)])])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "add-geo",
      "height": "auto",
      "scrollable": true,
      "classes": ['v--modal', 'vue-dialog'],
      "pivot-y": 0.3,
      "adaptive": true,
      "clickToClose": _vm.clickToClose
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [(_vm.addEditModal.mode == 'add') ? _c('div', {
    staticClass: "dialog-c-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("geospatial.Add geospatial optimization")) + "\n      ")]) : _c('div', {
    staticClass: "dialog-c-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("geospatial.Edit geospatial optimization")) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-c-text",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t("geospatial.Geospatial optimization name")))]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addEditModal.geoSummary.name),
      expression: "addEditModal.geoSummary.name"
    }],
    staticClass: "txbox",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.addEditModal.geoSummary.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addEditModal.geoSummary, "name", $event.target.value)
      }
    }
  }), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t("geospatial.Select regions")))]), _c('br'), _vm._v(" "), _vm._l((_vm.addEditModal.geoSummary.dataset_selections), function(selection) {
    return _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (selection.active),
        expression: "selection.active"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": selection.active,
        "checked": Array.isArray(selection.active) ? _vm._i(selection.active, selection.active) > -1 : (selection.active)
      },
      on: {
        "change": function($event) {
          var $$a = selection.active,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = selection.active,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(selection, "active", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(selection, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(selection, "active", $$c)
          }
        }
      }
    }), _vm._v("\n          " + _vm._s(selection.name))])
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "scrolltable",
    staticStyle: {
      "max-height": "30vh"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("geospatial.Optimization objective")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("geospatial.Weight")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.addEditModal.geoSummary.weightslist), function(item) {
    return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(item.label) + "   \n              ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.weight),
        expression: "item.weight"
      }],
      staticClass: "txbox",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.weight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "weight", $event.target.value)
        }
      }
    }), _c('br')])])
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t("geospatial.Existing spending")))]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addEditModal.geoSummary.fix_curr),
      expression: "addEditModal.geoSummary.fix_curr"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.addEditModal.geoSummary.fix_curr, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.addEditModal.geoSummary, "fix_curr", false)
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t("common.Can be reallocated"))), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addEditModal.geoSummary.fix_curr),
      expression: "addEditModal.geoSummary.fix_curr"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.addEditModal.geoSummary.fix_curr, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.addEditModal.geoSummary, "fix_curr", true)
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t("common.Cannot be reallocated"))), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t("geospatial.Regional spending")))]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addEditModal.geoSummary.fix_regionalspend),
      expression: "addEditModal.geoSummary.fix_regionalspend"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.addEditModal.geoSummary.fix_regionalspend, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.addEditModal.geoSummary, "fix_regionalspend", false)
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t("geospatial.Can be reallocated between regions"))), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addEditModal.geoSummary.fix_regionalspend),
      expression: "addEditModal.geoSummary.fix_regionalspend"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.addEditModal.geoSummary.fix_regionalspend, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.addEditModal.geoSummary, "fix_regionalspend", true)
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t("geospatial.Cannot be reallocated between regions"))), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t("optimization.Growth type")))]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addEditModal.geoSummary.growth),
      expression: "addEditModal.geoSummary.growth"
    }],
    attrs: {
      "type": "radio",
      "value": "fixed budget"
    },
    domProps: {
      "checked": _vm._q(_vm.addEditModal.geoSummary.growth, "fixed budget")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.addEditModal.geoSummary, "growth", "fixed budget")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t("optimization.Fixed budget"))), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addEditModal.geoSummary.growth),
      expression: "addEditModal.geoSummary.growth"
    }],
    attrs: {
      "type": "radio",
      "value": "fixed coverage"
    },
    domProps: {
      "checked": _vm._q(_vm.addEditModal.geoSummary.growth, "fixed coverage")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.addEditModal.geoSummary, "growth", "fixed coverage")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t("optimization.Fixed coverage"))), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t("geospatial.Additional funds to allocate")))]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addEditModal.geoSummary.add_funds),
      expression: "addEditModal.geoSummary.add_funds"
    }],
    staticClass: "txbox",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.addEditModal.geoSummary.add_funds)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addEditModal.geoSummary, "add_funds", $event.target.value)
      }
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "scrolltable",
    staticStyle: {
      "max-height": "30vh"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("common.Program name")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t("Include")) + "?")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.addEditModal.geoSummary.spec), function(spec) {
    return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(spec.name) + "\n              ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (spec.included),
        expression: "spec.included"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(spec.included) ? _vm._i(spec.included, null) > -1 : (spec.included)
      },
      on: {
        "change": function($event) {
          var $$a = spec.included,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(spec, "included", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(spec, "included", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(spec, "included", $$c)
          }
        }
      }
    })])])
  }), 0)])])], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn __green",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        return _vm.modalSave()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("Save")) + "\n        ")]), _vm._v("\n           \n        "), _c('button', {
    staticClass: "btn __red",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('add-geo')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("Cancel")) + "\n        ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18ecb641","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/GeospatialPage.vue
// module id = 361
// module chunks = 1